import { GenericComponent } from '../../components/GenericComponent';
import { Usuarios } from '../../models/Usuarios';
import { useForm } from 'react-hook-form';
import { UsuarioService } from '../../service/UsuarioService';
import { useEffect, useRef, useState } from 'react';
import { InputComponent } from '../../components/InputComponent';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { RolUsuario } from './RolUsuario';
import { AsignarPermiso } from './AsignarPermiso';
import { useToken } from '../../components/useToken';
import { EmpresaUsuario } from './EmpresaUsuario';
import { MenuFuncion } from './MenuFuncion';
import { useLazyParams } from '../../hooks/useLazyParams';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { TablaDinamica } from '../../components/TablaDinamica';
import { Menu } from 'primereact/menu';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.addVirtualFileSystem(pdfFonts);

export const Usuario = () => {

    const generic = new GenericComponent();
    const omodel = new Usuarios();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const { getRol } = useToken();
    const usuarioService = new UsuarioService();
    const toast = useRef(null);
    const [dialogUsuario, setDialogUsuario] = useState(false);
    const [usuario, setUsuario] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [rolDialog, setRolDialog] = useState(false);
    const [dialogFuncion, setDialogFuncion] = useState(false)
    const [load, setLoad] = useState(false);
    const [dialogPermisos, setDialogPermisos] = useState(false);
    const [opcion, setOpcion] = useState(null);
    const [dialogEtiqueta, setDialogEtiqueta] = useState(false);
    const [dialogEmpresaUsuario, setDialogEmpresaUsuario] = useState(false);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);
    const { inDrop, inSwitch, inText, inDropMultiple } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const [loadPdf, setLoadPdf] = useState(false);
    const [loadExcel, setLoadExcel] = useState(false);

    useEffect(() => {
        loadLazyData();
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
            _lazyParams.rol = getRol()?.id;
        }
        usuarioService.getUsuarios({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
                setCatalogos(res.data.catalogos);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const openNew = () => {
        setUsuario(null);
        if (catalogos == null) {
            usuarioService.newUsuario({ iniciar: 1 }).then(res => {
                setDialogUsuario(true);
                reset(defaultValues);
            });
        }
        else {
            setDialogUsuario(true);
            reset(defaultValues);
        }
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            setLoad(true);
            usuarioService.newUsuario(data).then(res => {
                setLoad(false);
                generic.funcSuccess(res, toast);
                setDialogUsuario(false);
                loadLazyData();
            }).catch(error => {
                setLoad(false);
                generic.funcError(error, toast, setError);
            });
        }
        else {
            usuarioService.editarUsuario(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogUsuario(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editUsuario = () => {
        const iniciar = catalogos == null ? 1 : null;
        usuarioService.consultarUsuario(usuario?.id, iniciar).then(res => {
            let cats = catalogos;
            let _user = res.data.usuario;
            const lista = { empresa: cats.lista, tipo_negocio: cats.negocio };

            Object.keys(lista).forEach(function (key) {
                if (_user[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _user[key]) {
                            _user[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_user, omodel.model));
            setDialogUsuario(true);
        });
    };

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la empresa?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarUsuario()
        });
    }

    const eliminarUsuario = () => {
        usuarioService.eliminarUsuario(usuario.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const asignarRol = (rol = true) => {
        setRolDialog(rol);
        setDialogPermisos(!rol);
    }

    const habilitar = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la sesión del usuario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => habilitarUsuario()
        });
    }

    const habilitarUsuario = () => {
        usuarioService.habilitar({ usuario: usuario?.id }).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const cambioEnvio = () => {
        confirmDialog({
            message: '¿Está seguro de cambiar la contraseña y enviar al correo ' + usuario?.email + '?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => cambioEnvioUsuario()
        });
    }

    const cambioEnvioUsuario = () => {
        tablaEstado.setLoading(true);
        usuarioService.cambioEnvio({ ids: usuario?.id }).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const rightToolbarTemplate = () => {
        if (!siOpcion('USUARIO-DESCARGAR-REPORTES')) {
            return null;
        }
        return (
            <>
                <Button onClick={() => generarReporteUsuario('xlsx')} className="p-button-success mr-2" type="button" tooltip='Descargar Excel' icon={loadExcel ? "pi pi-spin pi-spinner" : "pi pi-file-excel"} disabled={loadExcel || loadPdf} tooltipOptions={{ position: 'left' }} />
                <Button onClick={() => generarReporteUsuario('pdf')} className="p-button-warning mr-2" type="button" tooltip='Descargar PDF' icon={loadPdf ? "pi pi-spin pi-spinner" : "pi pi-file-pdf"} disabled={loadExcel || loadPdf} tooltipOptions={{ position: 'left' }} />
            </>
        );
    };

    const generarReporteUsuario = (tipo) => {
        const hoyFormateado = new Date().toISOString().split('T')[0];
        const params = { tipo: tipo, rol: getRol() };
        if (tipo === 'xlsx') {
            setLoadExcel(true);
            usuarioService.generarDocumento(params).then(res => {
                generic.downloadPdf(res.data, `Reporte_Usuarios_${hoyFormateado}.xlsx`);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Reporte Excel descargado correctamente', life: 3000 });
            }).catch((err) => {
                generic.funcErrorHibrida(err, toast, setError);
            }).finally(() => {
                setLoadExcel(false);
            });
        } else if (tipo === 'pdf') {
            setLoadPdf(true);
            usuarioService.consultarReporte(params).then(res => {
                const { info, detalle } = res.data;
                const docDefinition = Usuarios.getReportTemplate(detalle, info);
                pdfMake.createPdf(docDefinition).download(`Reporte_Usuarios_${hoyFormateado}.pdf`);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Reporte PDF generado correctamente', life: 3000 });
            }).catch((err) => {
                generic.funcErrorHibrida(err, toast, setError);
            }).finally(() => {
                setLoadPdf(false);
            });
        }
    };

    const itemsMenu = () => {
        const items = [];
        if (opcion && opcion !== 'sin') {
            if (siOpcion('USUARIO-EDITAR')) items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editUsuario() } });
            if (siOpcion('USUARIO-ASIGNAR-ROL')) items.push({ label: 'Asignar rol', icon: 'pi pi-key', command: () => { asignarRol() } });
            if (siOpcion('USUARIO-HABILITAR-SESION')) items.push({ label: 'Habilitar sesión', icon: 'pi pi-check-circle', command: () => { habilitar() } });
            if (siOpcion('USUARIO-RESETO-ENVIO')) items.push({ label: 'Resetear clave y enviar al correo', icon: 'pi pi-envelope', command: () => { cambioEnvio() } });
            if (siOpcion('USUARIO-OTROS-PERMISOS')) items.push({ label: 'Otros permisos', icon: 'pi pi-paypal', command: () => { asignarRol(false) } });
            if (siOpcion('USUARIO-ASIGNAR-EMPRESA')) items.push({ label: 'Asignar Empresas/Grupos', icon: 'pi pi-building-columns', command: () => { setDialogEmpresaUsuario(true) } });
            if (siOpcion('USUARIO-ASIGNAR-FUNCIONALIDAD-MENU')) items.push({ label: 'Asignar funcionalidad por menú', icon: 'pi pi-facebook', command: () => { setDialogFuncion(true) } });
            if (siOpcion('USUARIO-ELIMINAR')) items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
            if (permss?.actualizar)
                items.push({ label: 'Menús - asignar etiquetas', icon: 'pi pi-gauge', command: () => { setDialogEtiqueta(true) } });
        }

        return [{ label: 'Opciones', items: items }];
    }

    const tooltip_text = {
        habilitar: 'Habilita o deshabilita el acceso del usuario al sistema',
        google2fa: 'Activa o desactiva la autenticación en dos pasos',
        firmaDigital: 'Habilita o deshabilita la firma electrónica en los formularios principales',
    }

    const siEdicion = (opcion = {}) => {
        const res = opcion;
        res.readOnly = usuario?.fecha;
        return res;
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setUsuario(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo usuario', permss)} end={rightToolbarTemplate()}></Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>

            <Dialog visible={dialogUsuario} header={getValues('id') == null ? "Nuevo usuario" : "Editar usuario"} modal className="p-fluid modal-ssize"
                style={{ maxWidth: '700px' }} onHide={e => setDialogUsuario(false)}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('nombre', siEdicion(), 6)}
                        {inText('identificacion', siEdicion(), 6)}
                        {inText('login', siEdicion(), 6)}
                        {inText('email', {}, 6)}
                        {inSwitch('estado', { labelTrue: 'SI', labelFalse: 'NO', tooltip: tooltip_text.habilitar }, 6)}
                        {inSwitch('google_2fa_enabled', { labelTrue: 'SI', labelFalse: 'NO', tooltip: tooltip_text.google2fa }, 6)}
                        {inSwitch('firma_digital_activa', { labelTrue: 'SI', labelFalse: 'NO', tooltip: tooltip_text.firmaDigital }, 6)}
                        {inDrop('empresa', catalogos?.lista, { lab: omodel.optionLabel }, 6)}
                        {!getValues('id') && inDrop('enviar', generic.sino, { lab: omodel.optionLabel }, 6)}
                        {inDropMultiple('tipo_negocio', catalogos?.negocio, { lab: omodel.optionLabel }, 6)}
                    </div>
                    {generic.buttonsForms(setDialogUsuario, load)}
                </form>
            </Dialog>

            <Dialog visible={rolDialog} header={"Roles del usuario " + usuario?.nombre} modal className="p-fluid modal-ssize" onHide={e => setRolDialog(false)}>
                <RolUsuario id={usuario?.id} toast={toast} generic={generic} permss={permss} />
            </Dialog>

            <Dialog visible={dialogPermisos} header={"Otros permisos usuario: " + usuario?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogPermisos(false)}
                style={{ maxWidth: '900px' }}>
                <AsignarPermiso usuario={usuario?.id} toast={toast} generic={generic} />
            </Dialog>

            <Dialog visible={dialogEmpresaUsuario} header={"Asignar empresas/grupos a usuario: " + usuario?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogEmpresaUsuario(false)}
                style={{ maxWidth: '900px' }}>
                <EmpresaUsuario id={usuario?.id} toast={toast} generic={generic} permss={permss} />
            </Dialog>

            <Dialog visible={dialogFuncion} header={"Asignar menú-funcionalidad: " + usuario?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogFuncion(false)}
                style={{ maxWidth: '900px' }}>
                <MenuFuncion usuario={usuario?.id} toast={toast} generic={generic} permss={permss} />
            </Dialog>

            <Dialog visible={dialogEtiqueta} header={"Asignar etiquetas: " + usuario?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogEtiqueta(false)}
                style={{ maxWidth: '900px' }}>
                {<MenuFuncion usuario={usuario?.id} toast={toast} generic={generic} permss={permss} opcion="usuario" lista={catalogos?.negocio} />}
            </Dialog>
        </>
    )
}
